import { IconProps } from "../../models/Icon";

export function PlusIcon({ size = 20, color = "#000", opacity = "1" }: IconProps) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.46863 1.37598H6.53113C6.44779 1.37598 6.40613 1.41764 6.40613 1.50098V6.40723H1.75024C1.66691 6.40723 1.62524 6.44889 1.62524 6.53223V7.46973C1.62524 7.55306 1.66691 7.59473 1.75024 7.59473H6.40613V12.501C6.40613 12.5843 6.44779 12.626 6.53113 12.626H7.46863C7.55196 12.626 7.59363 12.5843 7.59363 12.501V7.59473H12.2502C12.3336 7.59473 12.3752 7.55306 12.3752 7.46973V6.53223C12.3752 6.44889 12.3336 6.40723 12.2502 6.40723H7.59363V1.50098C7.59363 1.41764 7.55196 1.37598 7.46863 1.37598Z" fill="black" fill-opacity="0.85" />
    </svg>

  )
}